import { render, staticRenderFns } from "./CollapseHintMessage.vue?vue&type=template&id=6423c2ca&scoped=true&"
import script from "./CollapseHintMessage.vue?vue&type=script&lang=ts&"
export * from "./CollapseHintMessage.vue?vue&type=script&lang=ts&"
import style0 from "./CollapseHintMessage.vue?vue&type=style&index=0&id=6423c2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6423c2ca",
  null
  
)

export default component.exports